"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.googleAdsAddKeywords = exports.googleAdsAddKeywordsResultSchema = exports.googleAdsAddKeywordsArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
var googleAdsAddKeywordsInputSchema = zod_1.z
    .object({
    adGroupId: zod_1.z.string().describe('The ID of the ad group where the keywords will be added'),
    keywords: zod_1.z.array(zod_1.z.string().min(1)).describe('Array of keyword text strings to add'),
    matchType: zod_1.z
        .enum(['EXACT', 'PHRASE', 'BROAD'])
        .default('PHRASE')
        .describe('Match type applied to all keywords. EXACT=[keyword], PHRASE="keyword", BROAD=keyword'),
    cpcBidMicros: zod_1.z
        .number()
        .positive()
        .nullish()
        .describe('CPC bid in micros applied to all keywords (e.g., 1000000 = $1.00). If not specified, uses ad group default.'),
    negative: zod_1.z
        .boolean()
        .default(false)
        .describe('Whether these are negative keywords (prevents ads from showing for these terms)'),
})
    .describe('Add keywords to a Google Ads ad group');
exports.googleAdsAddKeywordsArgsSchema = (0, common_1.GoogleAdsNodeArgsSchema)(googleAdsAddKeywordsInputSchema);
var keywordResultSchema = zod_1.z.object({
    keyword: zod_1.z.string(),
    matchType: zod_1.z.enum(['EXACT', 'PHRASE', 'BROAD']),
    criterionId: zod_1.z.string().nullish(),
    resourceName: zod_1.z.string().nullish(),
    success: zod_1.z.boolean(),
    error: zod_1.z.string().nullish(),
    negative: zod_1.z.boolean().nullish(),
    cpcBidMicros: zod_1.z.number().nullish(),
});
var googleAdsAddKeywordsResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
    keywords: zod_1.z.array(keywordResultSchema),
    message: zod_1.z.string().nullish(),
});
exports.googleAdsAddKeywordsResultSchema = googleAdsAddKeywordsResponseSchema;
exports.googleAdsAddKeywords = (0, common_1.createEmitModeToolMetadata)({
    id: 'googleAdsAddKeywords',
    displayName: 'Google Ads Add Keywords',
    displayDescription: 'Add keywords to a Google Ads ad group with specified match types and bids',
    category: 'ads',
    color: common_1.BRAND_COLORS.GOOGLE_ADS,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.GOOGLE_ADS),
    icon: 'google_ads',
    argsSchema: exports.googleAdsAddKeywordsArgsSchema,
}, googleAdsAddKeywordsResponseSchema);
